document.addEventListener('click', async (event) => {
  const discountFormButton = event.target.closest('.discount__form-button');
  if (!discountFormButton) return;

  event.preventDefault();
  event.stopPropagation();

  const discountForm = discountFormButton.closest('.discount__form');
  if (!discountForm) return;

  const discountFormInput = discountForm.querySelector('.discount__form-input input');
  const discountFormError = discountForm.querySelector('.discount__form-error');

  const showError = (message) => {
    if (discountFormError) {
      discountFormError.innerText = message;
      discountFormError.style.display = 'block';
    }
    discountFormInput.setAttribute('aria-invalid', 'true');
    discountForm.classList.add('is-error');
    discountForm.classList.remove('is-success');
  };

  const clearError = () => {
    if (discountFormError) discountFormError.style.display = 'none';
    discountFormInput.setAttribute('aria-invalid', 'false');
    discountForm.classList.remove('is-error');
  };

  const discount_code = discountFormInput.value.trim();

  if (!discount_code) {
    showError(theme.settings.discount_form_error_message_valid);
    return;
  }

  try {
    discountFormButton.classList.add('is--loading');
    discountFormButton.setAttribute('aria-busy', 'true');
    clearError();

    const cartResponse = await fetch(window.Shopify.routes.root + 'cart.js');
    const cartData = await cartResponse.json();

    const existingTitles = cartData.cart_level_discount_applications.map(item => item.title);
    const existingDiscountCodes = cartData.discount_codes ? cartData.discount_codes.map(item => item.code) : [];
    const discountString = [...existingTitles, ...existingDiscountCodes, discount_code].join(',');

    const formData = new FormData();
    formData.append('discount', discountString);

    const updateResponse = await fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      body: formData
    });
    const updatedCart = await updateResponse.json();

    let isFoundCode = updatedCart.cart_level_discount_applications.some(
      item => item.discount_application && item.discount_application.title.trim().toLowerCase() === discount_code.toLowerCase()
    );

    if (!isFoundCode && updatedCart.discount_codes) {
      isFoundCode = updatedCart.discount_codes.some(
        item => item.applicable === true && item.code.toLowerCase() === discount_code.toLowerCase()
      );
    }

    if (isFoundCode) {
      discountForm.classList.add('is-success');
      discountFormInput.value = '';
      
      if (discountFormError) {
        discountFormError.innerText = 'Discount applied successfully';
        discountFormError.style.display = 'block';
      }

      if (window.rerenderCart) {
        window.rerenderCart();
      }
    } else {
      showError(theme.settings.discount_form_error_message);
    }

    if (window.getSectionHTML) {
      window.getSectionHTML();
    }
  } catch (error) {
    console.error('Discount Application Error:', error);
    showError(theme.settings.discount_form_error_message);
  } finally {
    discountFormButton.classList.remove('is--loading');
    discountFormButton.setAttribute('aria-busy', 'false');
  }
});